import React from "react"
import { Route, Switch } from "react-router-dom"
import { AreaHeader, Content, DesktopSensorsReportsButton } from "../../components"
import { useQuerySettings } from "../../data"
import Sensors from "./Sensors"
import Sensor from "./Sensor"
import { useAuth } from "../../services"

const Index = () => {
  const { lang } = useQuerySettings()
  const { location } = useAuth()

  return (
    <>
      <AreaHeader
        title={lang.area.sensors}
        titleIcon="sensors"
        subTitle={location ? location.name : null}
        desktopButtons={<DesktopSensorsReportsButton />}
      />

      <Content full start mb={5}>
        <Switch>
          <Route path="/sensors/:id/:days" component={Sensor} />
          <Route path="/sensors" component={Sensors} />
        </Switch>
      </Content>
    </>
  )
}

export default Index
